"use client";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { NotFoundPageIcon } from "@/config/image-config";
import { useTranslation } from "@/hooks/useTranslation.hook";
import Image from "next/image";

import { useRouter } from "next/navigation";
import { Suspense } from "react";

const NotFoundContent = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const handleRouteChange = () => {
    router.replace("/");
  };

  return (
    <main className="min-h-screen w-full bg-background flex items-center justify-center">
      <div className="w-full max-w-[820px] mx-auto px-6 text-center flex flex-col items-center gap-10">
        <div className="flex items-end justify-center gap-4 select-none">
          <Image
            src={NotFoundPageIcon}
            alt="4"
            width={1098}
            height={500}
            priority
          />
        </div>

        <div className="space-y-2">
          <h2 className="text-dark text-2xl font-semibold">
            {t("Oops page not found")}
          </h2>
          <p className="text-base text-muted-foreground">
            {t("Sorry, the page you're looking for doesn't exist")}
          </p>
        </div>
        <Button className="px-6 py-2" onClick={handleRouteChange}>
          {t("Go Back Home")}
        </Button>
      </div>
    </main>
  );
};

const NotFoundPage = () => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen bg-background">
          <Spinner className="h-10 w-10 animate-spin" />
        </div>
      }
    >
      <NotFoundContent />
    </Suspense>
  );
};

export default NotFoundPage;
